import { render, staticRenderFns } from "./IcoContact.vue?vue&type=template&id=1bd0de5e"
import script from "./IcoContact.vue?vue&type=script&lang=js"
export * from "./IcoContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports